var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"Calendar Wrapper"},[_c('BaseNavbar',{attrs:{"className":"Calendar-Nav","navItems":_vm.years,"activeNavIndex":_vm.activeYearIndex}}),_c('CalendarTable',{attrs:{"year":_vm.year,"posts":_vm.posts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }